import Constants from 'expo-constants';

export default function isEnidma() {
  const slug = Constants.expoConfig?.slug;
  return slug === 'mytapsapp';
}
